import { TFunction } from "i18next";
import * as React from "react";
import { LimitsAndClosureDataType } from "../../containers/LimitsAndClosureContainter/LimitsAndClosureContainer";
import Disclaimer from "../Disclaimer/Disclaimer";
import InformationIcon from "../Icon/Icon";
import IconSuccess from "../IconSuccess/IconSuccess";

// tslint:disable-next-line:no-var-requires
export interface DisclaimerProps {
    screen: string;
    futureLimit: LimitsAndClosureDataType["futureLimit"];
    t: TFunction;
}
/* tslint:disable:jsx-no-multiline-js */
const LimitDisclaimer = ({ t, screen, futureLimit }: DisclaimerProps) => {
    return (
        <>
            {futureLimit.activateDate === 0 ||
            futureLimit.activateDate === null ? (
                <Disclaimer>
                    <InformationIcon />
                    {t(`${screen}.DisclaimerText`)}
                </Disclaimer>
            ) : (
                <Disclaimer>
                    <IconSuccess />
                    {t(`${screen}.FutureLimitText`, {
                        futureLimitDay: new Date(
                            futureLimit.activateDate
                        ).getDate(),
                        futureLimitMonth:
                            new Date(futureLimit.activateDate).getMonth() + 1,
                        futureLimitValidity: t(`${screen}.Validity`, {
                            returnObjects: true
                        })[futureLimit.period],
                        futureLimitValue: futureLimit.value,
                        futureLimitYear: new Date(
                            futureLimit.activateDate
                        ).getFullYear()
                    })}
                </Disclaimer>
            )}
        </>
    );
};

export default LimitDisclaimer;
